import { Store, StoreHelper, UserService } from '../services';

export class BaseComponent {
    constructor(
        public store: Store,
        public storeHelper: StoreHelper,
        public userService: UserService) { }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/models/base.component.ts